export default {
    props: {

      },
    data() {
        return {
         
        };
      },
      computed: {
        isMovil() {
          //console.log('isMovil = ' + this.$store.getters.getMovilView)
          return this.$store.getters.getMovilView;
        },
        isUltrawide() {
          //console.log('isUltrawide = ' + this.$store.getters.getUltrawidelView)
          return this.$store.getters.getUltrawidelView;
        },
        isLandscape() {
          //console.log('islandscape = ' + this.$store.getters.getMovilLandcape)
          return this.$store.getters.getMovilLandcape;
        }
      },
      created() { 
        this.handleView();
        window.addEventListener("resize", this.handleView);
      },
      beforeMount() {
        window.addEventListener('resize', this.handleView);
      },
      beforeUpdate() {
        this.handleView();
      },
      mounted() {

      },
      updated() {

      },
      methods: {
        handleView() {
            this.$store.dispatch("handleVisibility")
            // this.$store.dispatch("handleOrientation")
          },
      },
};